import React, { useEffect, useState } from "react";
import companyLogo from "assets/svg/hashfame-logo.svg";
import { LoginPageStyles } from "pages/Login/style";

import { WarningIcon } from "@phosphor-icons/react";

import Icon from "components/Icon/Icon";

// Centralized error messages (easy to update later)
const ERROR_MESSAGES = {
  oauth_failed: "Google login failed. Please try again.",
  unauthorized: "Access denied. Reach out to your admin.",
  no_email: "No email found in Google account.",
  server_error: "Server error. Please try again later.",
  default: "Login failed. Please try again."
};

const Login = () => {
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const errorParam = params.get("error");

    if (errorParam) {
      setLoginError(ERROR_MESSAGES[errorParam] || ERROR_MESSAGES.default);
    }
  }, []);

  const handleLogin = () => {
    // Redirect to backend OAuth
    window.location.href = "/api/auth/google";
  };

  return (
    <LoginPageStyles>
      <div className="login-container">
        {/* Header Section */}
        <div className="login-header">
          <img src={companyLogo} alt="Logo" className="login-logo" />
          <h1 className="login-title">Welcome to HashFame Admin Panel</h1>
          <span className="login-subtitle">
            Login with your Google account to get started
          </span>
        </div>

        {/* Google Login Section */}
        <div className="login-action">
          <button onClick={handleLogin} className="google-login-btn">
            <img
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
              alt="google logo"
              style={{ width: "20px", height: "20px" }}
            />
            Continue with Google
          </button>

          {/* Error Message */}
          {loginError && (
            <div className="warning-message">
              <Icon component={WarningIcon} color="#C62828" />
              <span className="warning-text">{loginError}</span>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="login-footer">
        <span>
          Facing Issues? <span className="contact-us">Contact us</span>
        </span>
      </div>
    </LoginPageStyles>
  );
};

export default Login;
